<template>

	<vuestic-navbar>

		<header-selector slot="selector" :isOpen.sync="valueProxy" />

		<span slot="logo" class="i-vuestic-3"></span>

    <span slot="logo" class="i-vuestic-4"></span>

		<span slot="center"></span>

		<!-- <message-dropdown /> -->

		<!-- <notification-dropdown /> -->

		<!-- <language-dropdown /> -->

		<profile-dropdown>

			<template slot="profile-name">
				{{ userData.name }} {{ userData.surname }}
        <!-- Luciano Santos -->
			</template>

		</profile-dropdown>

	</vuestic-navbar>

</template>

<script>
  import VuesticNavbar from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
  import HeaderSelector from './components/HeaderSelector'
  import LanguageDropdown from './components/dropdowns/LanguageDropdown'
  import ProfileDropdown from './components/dropdowns/ProfileDropdown'
  import NotificationDropdown from './components/dropdowns/NotificationDropdown'
  import MessageDropdown from './components/dropdowns/MessageDropdown'

  export default {
    name: 'app-navbar',

    components: {
      VuesticNavbar,
      HeaderSelector,
      MessageDropdown,
      NotificationDropdown,
      LanguageDropdown,
      ProfileDropdown
    },
    props: {
      isOpen: {
        type: Boolean,
        required: true
      },
      userData: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
      }
    },
    computed: {
      valueProxy: {
        get () {
          return this.isOpen
        },
        set (opened) {
          this.$emit('toggle-menu', opened)
        },
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/AppNavbar.vue